import { Module } from '../Module';

/**
* Makes angular's $q service more in line with the real q library: https://github.com/kriskowal/q
*
*   1. `catch` is aliased to `fail`. `catch` is a reserved word and breaks IE 7 & 8
*   2. `finally` is aliased to `fin`. `finally` is a reserved word and breaks IE 7 & 8
*   3. Add a `progress` shorthand for `then(null, null, notifyCallback)`
*
* Care is taken to minimize the overhead of this decoration.
*/
Module.instance().decorator('$q', ['$delegate', ($delegate: any) => {

    // Decorate all promises
    function decoratedThen() {
      return decoratePromise(this.originalThen.apply(this, arguments));
    }

    function decoratedCatch() {
      return decoratePromise(this.originalCatch.apply(this, arguments));
    }

    function decoratedFinally() {
      return decoratePromise(this.originalFinally.apply(this, arguments));
    }

    function progress(cb: Function) {
      return this.then(null, null, cb);
    }

    function decoratePromise(promise: any) {
      if (!!promise.originalThen) {
        // promise has already been decorated
        return promise;
      }

      promise.fin = promise['finally'];
      promise.fail = promise['catch'];
      promise.progress = progress;

      promise.originalThen = promise.then;
      promise.originalCatch = promise['catch'];
      promise.originalFinally = promise['finally'];

      promise.then = decoratedThen;
      promise['catch'] = decoratedCatch;
      promise['finally'] = decoratedFinally;

      return promise;
    }

    // Decorate all functions on $q
    function decoratedWhen() {
      return decoratePromise(this.originalWhen.apply(this, arguments));
    }

    function decoratedReject() {
      return decoratePromise(this.originalReject.apply(this, arguments));
    }

    function decoratedAll() {
      return decoratePromise(this.originalAll.apply(this, arguments));
    }

    function decoratedDefer() {
      const deferred = this.originalDefer.apply(this, arguments);
      deferred.promise = decoratePromise(deferred.promise);
      return deferred;
    }

    $delegate.originalWhen = $delegate.when;
    $delegate.originalReject = $delegate.reject;
    $delegate.originalAll = $delegate.all;
    $delegate.originalDefer = $delegate.defer;

    $delegate.when = decoratedWhen;
    $delegate.reject = decoratedReject;
    $delegate.all = decoratedAll;
    $delegate.defer = decoratedDefer;

    return $delegate;
}]);
